import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import { Block, Check } from '@mui/icons-material';

const types = {
  'DMA_REGION': 'DMA\'s',
  'POSTAL_CODE': 'ZIP Codes',
  'COUNTRY': 'Countries',
  'CITY': 'Cities',
  'PROVINCE': 'Provinces',
  'STATE': 'States',
  'TERRITORY': 'Territories',
  'NEIGHBORHOOD': 'Neighborhoods',
  'REGION': 'Regions',
  'COUNTY': 'Counties'
};

const styles = (/* theme */) => ({
  root: {
    padding: 15
  },
  divider: {
    marginBottom: 10
  },
  chip: {
    margin: '0 3px',
    border: '1px solid #888'
  }
});

class GeotargetSection extends Component {

  render() {
    const { classes, geotargets, excludedGeotargetIds, type, onDelete } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="subtitle1">
          {Object.prototype.hasOwnProperty.call(types, type) ? types[type] : type}
        </Typography>
        <Divider className={classes.divider} />
        {geotargets.map(g => (
          <Chip
            icon={ (excludedGeotargetIds || []).includes(g.id) ?  <Block /> : <Check />} 
            key={g.id}
            className={classes.chip}
            label={g.type === 'COUNTY' || g.type === 'CITY' ? g.canonicalName : g.name}
            onDelete={onDelete(g)}
          />
        ))}
      </div>
    );
  }
}

GeotargetSection.defaultProps = {
  type: null,
  geotargets: []
}

GeotargetSection.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.string,
  geotargets: PropTypes.arrayOf(PropTypes.object),
  onDelete: PropTypes.func.isRequired
};

export default withStyles(styles)(GeotargetSection);

